import { Component, inject, effect, ViewChild, input, output, ChangeDetectionStrategy } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import Swal from 'sweetalert2';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgbModal, NgbModule, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ClaimsManagementService } from './claims-management.service';
import { NgSelectModule } from '@ng-select/ng-select';
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
import { LOCALE_ID } from '@angular/core';
import { AuthService } from '@services/core/auth.service';
import { NgSelectComponent } from '@ng-select/ng-select';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { PartyOverviewComponent } from '../../../management-parties/pages/party-overview/party-overview.component';
import { ClaimOverviewComponent } from '../../components/claim-overview/claim-overview.component';
import { AppSettings } from '@services/settings/app-settings.service';
import { PageHeaderComponent } from 'app/core/components/page-header/page-header.component';
import { MobileFooterComponent } from 'app/core/components/mobile-footer/mobile-footer.component';
import { BottomSheetComponent } from 'app/core/components/bottom-sheet/bottom-sheet.component';
import { MasterDetailNav } from 'app/core/service/utils/master-detail-nav.service';






registerLocaleData(localeEs);

@Component({
  selector: 'app-claims-management',
  templateUrl: './claims-management.component.html',
  styleUrls: ['./claims-management.component.css'],
  standalone: true,
  imports: [
    CommonModule,
    NgbModule,
    NgSelectModule,
    PartyOverviewComponent,
    FormsModule,
    ClaimOverviewComponent,
    PageHeaderComponent,
    MobileFooterComponent,
    BottomSheetComponent
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  providers: [{ provide: LOCALE_ID, useValue: 'es-ES' }]
})
export class ClaimsManagementComponent {
  public Toast = Swal.mixin({
    toast: true, position: 'top-end'
    , showConfirmButton: false, timer: 2000, timerProgressBar: true
  })
  employeeType = input<number>();
  activeChange = output<boolean>();
  @ViewChild('preview', { static: true }) preview: any;
  @ViewChild('ngSelect') ngSelect: NgSelectComponent;
  @ViewChild('modalForm', { static: true }) modalForm: any;
  private modalRef: NgbModalRef;
  private authService = inject(AuthService)
  public appSettings = inject(AppSettings);
  private md = inject(MasterDetailNav);
  private readonly basePath = 'siniestros';
  public entity;
  public order: boolean = true;
  public orderColName: string = 'partyNames'
  public isLoading = true;
  public rows = Array.from({ length: 15 }, (_, i) => i + 1);
  public partiesDataReport;
  public pdfSrc
  public user;
  public entities;
  public isActiveClaim: boolean;
  partyOut;
  claimOut; // Siniestro seleccionado para mostrar detalle

  appHasAccess: string[] = [];

  public partiesData;
  public partiesDataTemp;
  public partiesSelected = [];
  public ngPartiesData;
  public ngEntitydata;
  public entitiesSelected = [];
  public ngStatusData;
  public statusSelected = [];

  // Filtros de la columna lateral
  public showEntityFilter = false;
  public showStatusFilter = false;
  public mobileFiltersOpen = false;

  get mobileFilterCount(): number {
    return (this.entitiesSelected?.length ? 1 : 0) + (this.statusSelected?.length ? 1 : 0);
  }


  constructor(private claimsManagementService: ClaimsManagementService,
    private modalService: NgbModal) {
    effect(() => {
      this.entity = this.authService.sharingEntity();
      this.user = this.authService.userData();
      if (this.entity && Object.keys(this.entity).length > 0) {

      }
    });
    this.md.urlChanges$.pipe(takeUntilDestroyed()).subscribe(() => this.syncFromRoute());
  }

  EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';



  showParty(party) {
    this.isActiveClaim = true;
    this.partyOut = party;
  }


  /*abre los modales */
  open(content, size: 'md' | 'lg' | 'xl' = 'lg') {
    this.modalRef = this.modalService.open(content, { size: size });
  }

  /*cierra los modales */
  close() {
    if (this.modalRef) {
      this.modalRef.close();
    }
  }



  ngOnInit(): void {
    this.getParties();
    // this.getEntitiesData();
  }


  showLoading(msg) {
    Swal.fire({
      title: msg,
      text: 'Por favor, espera',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });
  }

  hideLoading() {
    Swal.close();
  }



  /**metedo al precionar el boton de mostrar u ocultar filtro */


  getParties() {
    this.isLoading = true;
    this.claimsManagementService.getParties().subscribe(response => {
      this.isLoading = false;
      this.hideLoading()
      this.partiesData = response.sort((a, b) => a.statusCode - b.statusCode);
      this.partiesDataTemp = JSON.parse(JSON.stringify(response));
      this.ngPartiesData = this.formatDataNgSelectParties(this.partiesData);
      this.entities = this.getEntitiesGrouped(this.partiesData);
      this.ngEntitydata = this.formatDataNgSelectEntities(this.entities);
      this.ngStatusData = this.getStatusGrouped(this.partiesData).sort((a, b) => a.code - b.code);
      this.changeSelect();
      this.syncFromRoute();
    },
      error => {
        this.Toast.fire({ icon: 'warning', title: 'Error al obtener los datos ' + error });
        this.hideLoading();
        this.isLoading = false;
      })
  }

  getStatusGrouped(status) {
    const uniqueMap = new Map<number, any>();

    for (const p of status) {
      if (!uniqueMap.has(p.statusCode)) {
        uniqueMap.set(p.statusCode, {
          code: p.statusCode,
          name: p.statusName,
          isActive: p.statusIsActive ?? 0
        });
      }
    }

    // Convertimos el mapa en arreglo
    return Array.from(uniqueMap.values());
  }

  getEntitiesGrouped(parties) {
    const uniqueEntitiesMap = new Map<number, any>();

    for (const p of parties) {
      if (!uniqueEntitiesMap.has(p.entityCode)) {
        uniqueEntitiesMap.set(p.entityCode, {
          entityCode: p.entityCode,
          description: `${p.entityName} (${p.entityCampus})`,
          entityName: p.entityName,
          entityCampus: p.entityCampus
        });
      }
    }

    // Convertimos el mapa en arreglo
    return Array.from(uniqueEntitiesMap.values());
  }

  getEntitiesData() {
    this.claimsManagementService.getEntities().subscribe(response => {
      this.entities = response;
      this.ngEntitydata = this.formatDataNgSelectEntities(this.entities);
    },
      error => {
        console.log('error getFdrEntitiesData', error)
      })
  }

  formatDataNgSelectEntities(entities) {
    return entities.map(entity => {
      return {
        code: entity.entityCode,
        description: entity.entityCode + ' - ' + entity.entityCampus,
        disabled: false,
        isActive: true
      }
    });
  }

  changeSelect() {
    if (this.statusSelected.length > 0) {
      this.partiesData = this.partiesDataTemp.filter(party => this.statusSelected.includes(party.statusCode));
    }
    else {
      this.partiesData = this.partiesDataTemp;
    }
    if (this.partiesSelected.length > 0) {
      this.partiesData = this.partiesData.filter(party => this.partiesSelected.includes(party.id));
    }
    else {
      this.partiesData = this.partiesData;
    }
    this.changeSelectEntity();
  }

  changeSelectEntity() {
    if (this.entitiesSelected.length > 0) {
      this.partiesData = this.partiesData.filter(party => this.entitiesSelected.includes(party.entityCode));
    }
  }


  /**seleccionar todas las entidades filtra */
  allEntities() {
    const allEntities = this.ngEntitydata.map(e => e.code);
    this.entitiesSelected = allEntities;
    this.ngSelect?.close();
  }



  /**ordenar datos */
  orderCol(col: string) {
    this.order = !this.order;
    this.orderColName = col;
  }



  formatNumber(value: any): string {
    if (value == null) return '';
    return parseFloat(value).toLocaleString('de-DE', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    });
  }

  formatDataNgSelectParties(params) {
    return params.map(party => {
      return {
        id: party.id,
        rut: party.partyRut,
        rutNames: party.partyRut + ' - ' + party.partyNames,
        names: party.partyNames
      }
    });
  }




  dataExcel() {
    return this.partiesDataReport.map(detail => {
      return {
        Entidad: detail.entityCode,
        Rut: detail.accountRut,
        Nombres: detail.accountName,
        Total: detail.total ? detail.total : detail.startBalance
      }
    });
  }


  /**Obtener la fecha en formato 04/12/2024 09:36:44  */
  getDate() {
    let date = new Date();
    const options = { year: 'numeric', month: '2-digit', day: '2-digit' } as const; // Opciones para la fecha
    const formattedDate = date.toLocaleDateString('es-ES', options); // Formato DD-MM-YYYY
    const formattedTime = date.toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit', second: '2-digit' }); // Formato HH:mm:ss
    return `${formattedDate}_${formattedTime}`;
  }

  exportToExcel(): void {
    const worksheet = XLSX.utils.json_to_sheet(this.dataExcel());
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'FDR');
    const excelBuffer = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'array'
    });
    this.saveExcelFile(excelBuffer, 'fdr_cuentas_' + this.getDate());
  }

  private saveExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], { type: this.EXCEL_TYPE });
    saveAs(data, `${fileName}.xlsx`);
  }




  ActivateAccount(account) {
    this.claimsManagementService.updateFdrAccount({ id: account.accountId, user: account.user, status: 1 }).subscribe(response => {
      if (response != null) {
        this.Toast.fire({ icon: 'success', title: 'Cuenta Activada' });
        this.close();
      }
    },
      error => { console.log(error) })
  }




  getBalance(r: any): number {
    return r.total ?? r.startBalance ?? 0;
  }



  confirmDesactivate() {
    Swal.fire({
      icon: 'warning',
      title: 'Atención ',
      text: '¿Desea dar de baja la cuenta?',
      toast: false,
      position: 'center',
      showCancelButton: true,
      confirmButtonText: 'Aceptar',
      cancelButtonText: 'Cancelar',
      reverseButtons: true,
      timer: null,
      timerProgressBar: false
    }).then((result) => {
      if (result.isConfirmed) {
      }
    });
  }

  // Mostrar detalle del siniestro seleccionado
  showOverviewClaim(claim) {
    const id = this.claimId(claim);
    if (!id) return;
    if (this.md.detailSegment(this.basePath) === id) {
      this.claimOut = claim;
      return;
    }
    this.md.go(this.md.item(this.basePath, id));
  }

  closeOverviewClaim(_event?: any) {
    this.md.back(this.md.list(this.basePath));
  }

  private claimId(claim: any): string | null {
    if (!claim) return null;
    const id = claim.uuid ?? claim.id;
    return id != null ? String(id) : null;
  }

  private syncFromRoute(retries = 12) {
    const id = this.md.detailSegment(this.basePath);
    if (!id) {
      this.claimOut = null;
      this.isActiveClaim = false;
      return;
    }
    if (this.claimId(this.claimOut) === id) return;
    const found = (this.partiesDataTemp || this.partiesData || []).find((c) => this.claimId(c) === id);
    if (found) {
      this.claimOut = found;
      return;
    }
    if (retries > 0) setTimeout(() => this.syncFromRoute(retries - 1), 80);
  }

}



